import { render } from "./UETaxEditView.vue?vue&type=template&id=caa58ef8&scoped=true"
import script from "./UETaxEditView.vue?vue&type=script&lang=js"
export * from "./UETaxEditView.vue?vue&type=script&lang=js"

import "./UETaxEditView.vue?vue&type=style&index=0&id=caa58ef8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa58ef8"]])

export default __exports__